"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRotated = exports.getContainerHeight = exports.fitToContentHeight = exports.height = exports.bottom = exports.left = exports.top = void 0;
var _ = require("lodash");
exports.top = function (comp) { return comp.top; };
exports.left = function (comp) { return comp.left; };
exports.bottom = function (comp) { return comp.top + comp.height; };
exports.height = function (comp) { return comp.height; };
exports.fitToContentHeight = function (container) { return Boolean(container.fitToContentHeight); };
exports.getContainerHeight = function (container) { return _.max([container.height || 0, container.minHeight || 0]); };
exports.isRotated = function (component) { return _.isNumber(component.rotationInDegrees) && component.rotationInDegrees !== 0; };
//# sourceMappingURL=compLayoutUtils.js.map